// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"d844c44e","453":"64aababc"}[chunkId] + ".chunk.js";
};